export default __webpack_public_path__ + "static/media/black-1.dbc2079d.png";